export const actionTypes = {
  INIT_QUOTATION_TABLE:'INIT_QUOTATION_TABLE',
  TOGGLE_QUOTATION_CATEGORY_EDITING: 'TOGGLE_QUOTATION_CATEGORY_EDITING',
  SET_QUOTATION_CLASS_LIST: 'SET_QUOTATION_CLASS_LIST',
  SET_QUOTATION_CLASS_ADD_VISIBLE: 'SET_QUOTATION_CLASS_ADD_VISIBLE',
  TOGGLE_QUOTATION_INFO_CATEGORY_EDITING: 'TOGGLE_QUOTATION_INFO_CATEGORY_EDITING',
  SET_QUOTATION_LIST: 'SET_QUOTATION_LIST',
  SET_QUOTATION_LIST_PAGE: 'SET_QUOTATION_LIST_PAGE',
  SET_QUOTATION_SEARCH_CONDITION: 'SET_QUOTATION_SEARCH_CONDITION',
  SET_CURRENT_PRODUCT_GROUP: 'SET_CURRENT_PRODUCT_GROUP',
};


